import type { SalesFunnelStageFilterListDto } from '@app/api/Leads/types';
import type { SalesFunnelFilterDto } from '@app/api/SalesFunnels/types';
import type { LeadFunnelStageOption } from '@app/pages/Leads/ui/components/LeadFunnelStagesControl';

const UNNAMED_FUNNEL = 'Без названия';
const UNNAMED_STAGE = 'Без названия';

export const mapFunnelsToOptions = (
  funnels: SalesFunnelFilterDto[]
): LeadFunnelStageOption[] =>
  funnels.flatMap((funnel) =>
    (funnel.Stages ?? []).map((stage) => ({
      funnelId: funnel.Id,
      funnelName: funnel.Name || UNNAMED_FUNNEL,
      stageId: stage.Id,
      stageName: stage.Name || UNNAMED_STAGE,
      color: stage.Color,
    }))
  );

export const getAssignedStageId = (
  stage: SalesFunnelStageFilterListDto
): number | null => stage.Id ?? stage.StageId ?? null;

export const getAssignedStageFunnelId = (
  stage: SalesFunnelStageFilterListDto,
  option: LeadFunnelStageOption | undefined
): number | null => option?.funnelId ?? stage.SalesFunnelId ?? null;

const makeAssignedStage = (
  option: LeadFunnelStageOption
): SalesFunnelStageFilterListDto => ({
  Id: option.stageId,
  Name: option.stageName,
  Color: option.color,
  SalesFunnelId: option.funnelId,
  StageId: option.stageId,
});

export const patchStageAdd = (
  stages: SalesFunnelStageFilterListDto[],
  option: LeadFunnelStageOption,
  optionByStageId: Map<number, LeadFunnelStageOption>
): SalesFunnelStageFilterListDto[] => [
  ...stages.filter((stage) => {
    const stageId = getAssignedStageId(stage);
    const currentOption =
      stageId !== null ? optionByStageId.get(stageId) : undefined;

    return getAssignedStageFunnelId(stage, currentOption) !== option.funnelId;
  }),
  makeAssignedStage(option),
];

export const patchStageExchange = (
  stages: SalesFunnelStageFilterListDto[],
  currentStageId: number,
  option: LeadFunnelStageOption
): SalesFunnelStageFilterListDto[] =>
  stages.map((stage) =>
    getAssignedStageId(stage) === currentStageId
      ? makeAssignedStage(option)
      : stage
  );

export const patchStageDelete = (
  stages: SalesFunnelStageFilterListDto[],
  stageId: number
): SalesFunnelStageFilterListDto[] =>
  stages.filter((stage) => getAssignedStageId(stage) !== stageId);
